import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Button,
  FormHelperText,
} from "@mui/material";

const daysOfWeek = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
const shifts = ["Shift A", "Shift B", "Shift C"];
const employees = [
  { id: 1, name: "Alice" },
  { id: 2, name: "Bob" },
  { id: 3, name: "Charlie" },
  { id: 4, name: "David" },
];

const ShiftWeekOffScheduler = () => {
  const [weekNumber, setWeekNumber] = useState(1);
  const [weekOffs, setWeekOffs] = useState({}); // employeeId: ["Sunday",...]
  const [assignments, setAssignments] = useState({}); // employeeId: {day: shift}
  const [errors, setErrors] = useState({});

  // Example: preset some weekly offs
  useEffect(() => {
    setWeekOffs({
      1: ["Sunday"],
      2: ["Saturday"],
      3: ["Sunday","Saturday"],
      4: [],
    });
  }, []);

  // Generate assignments for the week
  const generateAssignments = (weekNum) => {
    const newAssignments = {};
    employees.forEach((emp, idx) => {
      newAssignments[emp.id] = {};
      daysOfWeek.forEach((day, dayIdx) => {
        // Skip if weekly off
        if ((weekOffs[emp.id] || []).includes(day)) {
          newAssignments[emp.id][day] = "Off";
        } else {
          const shiftIndex = (idx + dayIdx + (weekNum - 1)) % shifts.length;
          newAssignments[emp.id][day] = shifts[shiftIndex];
        }
      });
    });
    setAssignments(newAssignments);
    validateConflicts(newAssignments);
  };

  const validateConflicts = (assigns) => {
    const newErrors = {};
    daysOfWeek.forEach((day) => {
      const shiftCount = {};
      employees.forEach((emp) => {
        const shift = assigns[emp.id][day];
        if (shift !== "Off") {
          shiftCount[shift] = shiftCount[shift] || [];
          shiftCount[shift].push(emp.id);
        }
      });
      Object.entries(shiftCount).forEach(([shift, empIds]) => {
        if (empIds.length > 1) {
          empIds.forEach((id) => {
            newErrors[id] = newErrors[id] || {};
            newErrors[id][day] = `Conflict in ${shift}`;
          });
        }
      });
    });
    setErrors(newErrors);
  };

  const handleNextWeek = () => {
    const nextWeek = weekNumber + 1;
    setWeekNumber(nextWeek);
    generateAssignments(nextWeek);
  };

  const handlePrevWeek = () => {
    const prevWeek = weekNumber > 1 ? weekNumber - 1 : 1;
    setWeekNumber(prevWeek);
    generateAssignments(prevWeek);
  };

  useEffect(() => {
    generateAssignments(weekNumber);
  }, [weekOffs]);

  const handleSubmit = () => {
    if (Object.keys(errors).length > 0) {
      alert("Resolve conflicts before saving!");
      return;
    }
    console.log("Week Assignments:", assignments);
    alert("Weekly schedule saved successfully!");
  };

  return (
    <Box p={4}>
      <Typography variant="h5" gutterBottom>
        Shift + Weekly Off Scheduler - Week {weekNumber}
      </Typography>

      <Box mt={2} mb={2}>
        <Button variant="outlined" onClick={handlePrevWeek} sx={{ mr: 2 }}>
          Previous Week
        </Button>
        <Button variant="outlined" onClick={handleNextWeek}>
          Next Week
        </Button>
      </Box>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Employee</TableCell>
            {daysOfWeek.map((day) => (
              <TableCell key={day} align="center">{day}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {employees.map((emp) => (
            <TableRow key={emp.id}>
              <TableCell>{emp.name}</TableCell>
              {daysOfWeek.map((day) => (
                <TableCell key={day} align="center">
                  <Box color={(errors[emp.id]?.[day]) ? 'red' : 'inherit'}>
                    {assignments[emp.id]?.[day]}
                  </Box>
                  {errors[emp.id]?.[day] && (
                    <FormHelperText error>{errors[emp.id][day]}</FormHelperText>
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Box mt={4}>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Save Schedule
        </Button>
      </Box>
    </Box>
  );
};

export default ShiftWeekOffScheduler;
